.avatar {
  cursor: pointer;
}
